import { useDispatch } from 'react-redux';
import {
  getLocationWeather,
  getSingleGeneralReport,
  getGeneralPdfResource,
  clearReportListState,
  removeGeneralReport,
  upgradeGeneralReport,
  setLocationReportFilter,
  setAssetReportFilter,
  setGeneralReportFilter,
  getGeneralReportList,
  updateReport,
  getFilterCriteria,
  getCreationForm,
  getGeneralReportTemplateList,
  getShortedReportTemplates
} from 'actions/reportListActions';

export function useReportActions() {
  const dispatch = useDispatch();

  const getCreationFormAction = (q) => dispatch(getCreationForm(q));

  const setFilterAction = (data) => dispatch(setLocationReportFilter(data));
  const setAssetReportsFilterAction = (data) => dispatch(setAssetReportFilter(data));
  const setGeneralReportsFilterAction = (data) => dispatch(setGeneralReportFilter(data));

  const getReportsAction = (q) => dispatch(getGeneralReportList(q));
  const getGeneralReportsTemplatesAction = (query) => dispatch(getGeneralReportTemplateList(query));

  const updateReportAction = (data) => dispatch(updateReport(data));

  const getFilterCriteriaAction = (q) => dispatch(getFilterCriteria(q));

  const clearStateAction = () => dispatch(clearReportListState());

  const updateGeneralReportAction = (data, options) =>
    dispatch(upgradeGeneralReport(data, options));
  const getSingleGeneralReportAction = (id, type) => dispatch(getSingleGeneralReport(id, type));
  const getShortedGeneralReportsAction = (query) =>
    dispatch(
      getShortedReportTemplates({
        Filters: { GeneralReportTypeName: 'General' },
        Pagination: { Limit: 25, Page: 1 },
        ...query
      })
    );

  const removeGeneralReportAction = (data, options) => dispatch(removeGeneralReport(data, options));
  const getLocationWeatherAction = (options) => dispatch(getLocationWeather(options));
  const getPdfResourceAction = (id) => dispatch(getGeneralPdfResource(id));

  return {
    getCreationFormAction,
    updateGeneralReportAction,
    setFilterAction,
    setAssetReportsFilterAction,
    setGeneralReportsFilterAction,
    getReportsAction,
    updateReportAction,
    clearStateAction,
    getSingleGeneralReportAction,
    removeGeneralReportAction,
    getLocationWeatherAction,
    getPdfResourceAction,
    getFilterCriteriaAction,
    getGeneralReportsTemplatesAction,
    getShortedGeneralReportsAction
  };
}
